export const Logo: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='193.65'
			height='112.51'
			className='logoicon-svg'
			viewBox='0 0 193.65 112.511'>
			<g
				id='Group_4853'
				data-name='Group 4853'
				transform='translate(-284 -210.88)'>
				<g
					id='Group_4836'
					data-name='Group 4836'
					transform='translate(-236 -213.12)'>
					<g
						id='Group_4835'
						data-name='Group 4835'
						transform='translate(577 424)'>
						<path
							id='Path_3563'
							data-name='Path 3563'
							d='M352.679,544.793l-33.267,17.514a10.005,10.005,0,0,1-9.322,0l-33.267-17.514a2.811,2.811,0,0,1,.076-5.013L314.751,521.3,352.6,539.78A2.811,2.811,0,0,1,352.679,544.793Z'
							transform='translate(-275.322 -488.566)'
							fill='#ff83a4'
						/>
						<path
							id='Path_3564'
							data-name='Path 3564'
							d='M352.679,431.992l-33.267,17.514a10.006,10.006,0,0,1-9.322,0l-33.267-17.514a2.811,2.811,0,0,1,.076-5.013L314.751,408.5,352.6,426.979A2.811,2.811,0,0,1,352.679,431.992Z'
							transform='translate(-275.322 -387.096)'
							fill='#ffacc2'
							opacity='0.998'
						/>
						<path
							id='Path_3565'
							data-name='Path 3565'
							d='M352.679,319.821l-33.267,17.514a10.005,10.005,0,0,1-9.322,0l-33.267-17.514a2.811,2.811,0,0,1,.076-5.013l37.852-18.483L352.6,314.808A2.811,2.811,0,0,1,352.679,319.821Z'
							transform='translate(-275.322 -286.193)'
							fill='#ffd6e1'
						/>
						<path
							id='Path_3566'
							data-name='Path 3566'
							d='M352.679,217.826,319.412,235.34a10.006,10.006,0,0,1-9.322,0l-33.267-17.514a2.811,2.811,0,0,1,.076-5.013l33.461-16.339a10.005,10.005,0,0,1,8.781,0L352.6,212.813A2.811,2.811,0,0,1,352.679,217.826Z'
							transform='translate(-275.322 -195.459)'
							fill='#fff'
						/>
					</g>
				</g>
				<g id='AdCreative' transform='translate(13 73.191)'>
					<g
						id='Group_4'
						data-name='Group 4'
						transform='translate(271 222.173)'>
						<g id='Group_1' data-name='Group 1' transform='translate(0 0)'>
							<path
								id='Path_2_8_'
								d='M1585.226,350.1v27.462h-3.771v-2.414l-.117-.081a1.048,1.048,0,0,1-.11.22,7.44,7.44,0,0,1-12.106-.587,9.708,9.708,0,0,1,.9-12.04,7.368,7.368,0,0,1,10.91.154c.154.169.308.338.514.565V350.1Zm-8.834,24.219a5.1,5.1,0,1,0-5.143-5.026A5.115,5.115,0,0,0,1576.392,374.319Z'
								transform='translate(-1544.257 -350.1)'
								fill='#fff'
							/>
							<path
								id='Path_3_8_'
								d='M1263.139,381.8c3.911,8.408,7.792,16.758,11.688,25.158h-2.208c-.712,0-1.416-.007-2.128.007a.347.347,0,0,1-.382-.249c-.536-1.189-1.093-2.37-1.629-3.566a.432.432,0,0,0-.462-.293q-4.9.011-9.8,0a.461.461,0,0,0-.492.315q-.792,1.772-1.621,3.522c-.051.11-.191.25-.286.25-1.453.015-2.905.015-4.424.015C1255.318,398.565,1259.214,390.223,1263.139,381.8Zm3.25,16.919-3.25-7.08-3.287,7.08Z'
								transform='translate(-1251.4 -379.474)'
								fill='#fff'
							/>
						</g>
						<g
							id='Group_2'
							data-name='Group 2'
							transform='translate(43.309 2.325)'>
							<path
								id='Path_4_8_'
								d='M1863.5,385.489c-.961,1-1.907,1.988-2.854,2.971a8.7,8.7,0,0,0-12.62,11.959,8.386,8.386,0,0,0,6.236,2.9,8.524,8.524,0,0,0,6.383-2.524l2.869,2.964a12.827,12.827,0,1,1-.015-18.269Z'
								transform='translate(-1841.684 -381.783)'
								fill='#fff'
							/>
							<path
								id='Path_5_8_'
								d='M2543.889,506.608h-3.764v-2.414l-.073-.037c-.081.1-.161.183-.242.279a7.313,7.313,0,0,1-6.317,2.7,7.155,7.155,0,0,1-5.173-2.722,9.4,9.4,0,0,1-1.475-9.846,7.887,7.887,0,0,1,4.608-4.7,7.34,7.34,0,0,1,8.158,2.018c.147.161.294.323.5.558v-2.517h3.786v16.684Zm-8.937-3.243a5.1,5.1,0,1,0-5.041-5.2A5.111,5.111,0,0,0,2534.953,503.365Z'
								transform='translate(-2475.867 -481.47)'
								fill='#fff'
							/>
							<path
								id='Path_7_8_'
								d='M2287.081,499.872h-12.737c.081.183.125.33.2.462a5.6,5.6,0,0,0,4.145,2.9,6.485,6.485,0,0,0,5.818-1.658l2.626,2.737a9.421,9.421,0,0,1-2.641,1.834,10.445,10.445,0,0,1-11.592-1.754,8.259,8.259,0,0,1-2.385-8.415,8.385,8.385,0,0,1,15.921-1.453A9.346,9.346,0,0,1,2287.081,499.872Zm-3.962-3.258a4.649,4.649,0,0,0-4.542-3.456c-2,.1-4.138,1.827-4.248,3.456Z'
								transform='translate(-2238.758 -481.462)'
								fill='#fff'
							/>
							<path
								id='Path_8_8_'
								d='M3264.479,499.737c1.269,3.558,6.874,4.842,10.125,1.709.865.9,1.731,1.812,2.626,2.737a8.919,8.919,0,0,1-2.179,1.592,10.478,10.478,0,0,1-12.37-1.827,8.815,8.815,0,0,1,3.991-14.446,8.422,8.422,0,0,1,9.861,4.872,9.23,9.23,0,0,1,.667,5.2c-.007.044-.022.088-.037.161Zm-.066-3.258h8.812a4.539,4.539,0,0,0-8.812,0Z'
								transform='translate(-3156.229 -481.335)'
								fill='#fff'
							/>
							<path
								id='Path_9_8_'
								d='M3054.167,496.6c-2.957,5.789-5.884,11.5-8.834,17.271L3036.5,496.6h.858c.976,0,1.959.015,2.935-.007a.641.641,0,0,1,.7.418c1.365,2.693,2.751,5.371,4.13,8.049.059.117.125.227.213.389.081-.154.147-.264.206-.382l4.182-8.144a.509.509,0,0,1,.529-.33C3051.533,496.61,3052.81,496.6,3054.167,496.6Z'
								transform='translate(-2948.838 -488.171)'
								fill='#fff'
							/>
							<path
								id='Path_10_8_'
								d='M2798.71,441.314h-3.8V428.423h-3.61v-3.808h3.6v-1.834c0-.572-.008-1.152.007-1.724a.415.415,0,0,1,.154-.323c1.181-.609,2.37-1.2,3.617-1.834v5.7h3.977v3.8H2798.7Z'
								transform='translate(-2721.627 -416.177)'
								fill='#fff'
							/>
							<path
								id='Path_11_8_'
								d='M2165.258,493.466a4.033,4.033,0,0,0-3.14.594,3.977,3.977,0,0,0-1.753,3.478v9.274H2156.6V490.135h3.742v1.7l.081.059a6.862,6.862,0,0,1,2.157-1.68,5.843,5.843,0,0,1,2.678-.624Z'
								transform='translate(-2133.495 -481.681)'
								fill='#fff'
							/>
							<path
								id='Path_12_8_'
								d='M2968.6,497h3.742v16.677H2968.6Z'
								transform='translate(-2885.919 -488.547)'
								fill='#fff'
							/>
							<path
								id='Path_15_8_'
								d='M2968,388.058a2.249,2.249,0,1,1-2.216-2.26h.007A2.241,2.241,0,0,1,2968,388.058Z'
								transform='translate(-2881.191 -385.503)'
								fill='#fff'
							/>
						</g>
						<g
							id='Group_3'
							data-name='Group 3'
							transform='translate(166.629 3.771)'>
							<path
								id='Path_40_8_'
								d='M3584.739,498.436a22.077,22.077,0,0,1-1.819,2.282,8.165,8.165,0,0,1-12.656-1.306,9.234,9.234,0,0,1,.778-11.328,8.232,8.232,0,0,1,13.441,1.7.955.955,0,0,0,.235.308v-4.2h1.761v16.669h-1.731v-4.131Zm-7.153,2.927a7.135,7.135,0,1,0-7.139-7.131,7.136,7.136,0,0,0,7.139,7.131Z'
								transform='translate(-3565.297 -479.191)'
								fill='#fff'
							/>
							<path
								id='Path_45_8_'
								d='M3859.324,509.606h-1.489c-.074,0-.14-.007-.235-.015V492.9h1.717v16.706Z'
								transform='translate(-3833.014 -486.194)'
								fill='#fff'
							/>
							<path
								id='Path_46_8_'
								d='M3524.048,688.693a1.586,1.586,0,0,1-1.548-1.541,1.552,1.552,0,1,1,3.1.015A1.57,1.57,0,0,1,3524.048,688.693Z'
								transform='translate(-3522.5 -664.753)'
								fill='#fff'
							/>
							<path
								id='Path_48_8_'
								d='M3850.045,401.5a1.544,1.544,0,0,1,1.555,1.519,1.552,1.552,0,0,1-3.1.015A1.555,1.555,0,0,1,3850.045,401.5Z'
								transform='translate(-3824.579 -401.5)'
								fill='#fff'
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

///coloured

export const ColouredLogo: React.FC = () => {
	return (
		<svg
			// xmlns='http://www.w3.org/2000/svg'
			// xmlnsXlink='http://www.w3.org/1999/xlink'
			width='178.94'
			height='82.11'
			className='coloured-logo-icon'
			viewBox='0 0 158.639 72.797'>
			<defs>
				<linearGradient
					id='linear-gradient'
					x1='0.425'
					y1='0.235'
					x2='1.424'
					y2='2.133'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#ff3067' />
					<stop offset='1' stop-color='#a5009f' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-2'
					x1='-0.169'
					y1='-1.173'
					x2='1.055'
					y2='1.568'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-3'
					x1='-0.072'
					y1='-0.727'
					x2='1.211'
					y2='2.012'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-4'
					x1='-0.863'
					y1='-2.417'
					x2='0.42'
					y2='0.323'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-5'
					x1='-0.465'
					y1='-2.206'
					x2='0.769'
					y2='0.616'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-6'
					x1='-0.779'
					y1='-1.002'
					x2='1.142'
					y2='1.174'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-7'
					x1='-0.347'
					y1='-0.452'
					x2='2.173'
					y2='2.38'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-8'
					x1='-4.294'
					y1='-1.904'
					x2='1.537'
					y2='1.02'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-9'
					x1='-2.308'
					y1='-5.738'
					x2='2.542'
					y2='5.035'
					xlinkHref='#linear-gradient'
				/>
				<linearGradient
					id='linear-gradient-10'
					x1='0.5'
					x2='0.5'
					y2='1'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#8f006d' />
					<stop offset='1' stop-color='#4c00b3' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-11'
					x1='0.5'
					x2='0.5'
					y2='1'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#c8006d' />
					<stop offset='1' stop-color='#8200b3' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-12'
					x1='0.5'
					x2='0.5'
					y2='1'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#c8006d' />
					<stop offset='1' stop-color='#c5009f' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-13'
					x1='0.5'
					y1='-0.078'
					x2='0.5'
					y2='1.101'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#ff3067' />
					<stop offset='1' stop-color='#ff009f' />
				</linearGradient>
			</defs>
			<g id='AdCreative' transform='translate(-271 -161.25)'>
				<g id='Group_4' data-name='Group 4' transform='translate(271 211.087)'>
					<g id='Group_1' data-name='Group 1' transform='translate(0 0)'>
						<path
							id='Path_2_8_'
							d='M1582.011,350.1v22.5h-3.089V370.62l-.1-.066a.864.864,0,0,1-.09.18,6.1,6.1,0,0,1-9.917-.481,7.952,7.952,0,0,1,.733-9.863,6.036,6.036,0,0,1,8.938.126c.126.138.252.277.421.463V350.1Zm-7.237,19.84a4.178,4.178,0,1,0-4.213-4.117A4.19,4.19,0,0,0,1574.775,369.94Z'
							transform='translate(-1548.449 -350.1)'
							fill='#3b2a82'
						/>
						<path
							id='Path_3_8_'
							d='M1261.017,381.8c3.2,6.888,6.383,13.728,9.575,20.61h-1.809c-.583,0-1.16-.006-1.743.006a.284.284,0,0,1-.313-.2c-.439-.974-.9-1.941-1.334-2.921a.354.354,0,0,0-.378-.24q-4.012.009-8.024,0a.377.377,0,0,0-.4.258q-.649,1.451-1.328,2.885c-.042.09-.156.2-.234.2-1.19.012-2.38.012-3.624.012C1254.609,395.534,1257.8,388.7,1261.017,381.8Zm2.663,13.86-2.663-5.8-2.693,5.8Z'
							transform='translate(-1251.4 -379.895)'
							fill='#3b2a82'
						/>
					</g>
					<g
						id='Group_2'
						data-name='Group 2'
						transform='translate(35.478 1.904)'>
						<path
							id='Path_4_8_'
							d='M1859.56,384.819c-.787.817-1.563,1.629-2.338,2.434a7.124,7.124,0,0,0-10.338,9.8,6.87,6.87,0,0,0,5.109,2.374,6.983,6.983,0,0,0,5.229-2.068l2.35,2.428a10.508,10.508,0,1,1-.012-14.966Z'
							transform='translate(-1841.684 -381.783)'
							fill='url(#linear-gradient)'
						/>
						<path
							id='Path_5_8_'
							d='M2540.669,503.49h-3.084v-1.977l-.06-.03c-.066.078-.132.15-.2.228a5.99,5.99,0,0,1-5.175,2.212,5.862,5.862,0,0,1-4.238-2.23,7.7,7.7,0,0,1-1.208-8.066,6.461,6.461,0,0,1,3.775-3.853,6.013,6.013,0,0,1,6.683,1.653c.121.132.24.264.409.457v-2.062h3.1V503.49Zm-7.321-2.657a4.178,4.178,0,1,0-4.129-4.261A4.187,4.187,0,0,0,2533.349,500.834Z'
							transform='translate(-2484.946 -482.897)'
							fill='url(#linear-gradient-2)'
						/>
						<path
							id='Path_7_8_'
							d='M2284.028,497.97h-10.434c.066.15.1.27.162.379a4.588,4.588,0,0,0,3.4,2.374,5.312,5.312,0,0,0,4.766-1.358l2.152,2.242a7.718,7.718,0,0,1-2.164,1.5,8.557,8.557,0,0,1-9.5-1.437,6.766,6.766,0,0,1-1.953-6.894,6.869,6.869,0,0,1,13.043-1.19A7.658,7.658,0,0,1,2284.028,497.97Zm-3.246-2.669a3.808,3.808,0,0,0-3.72-2.831c-1.641.078-3.39,1.5-3.48,2.831Z'
							transform='translate(-2244.442 -482.889)'
							fill='url(#linear-gradient-3)'
						/>
						<path
							id='Path_8_8_'
							d='M3263.726,497.835c1.039,2.915,5.631,3.967,8.294,1.4.709.739,1.418,1.485,2.152,2.242a7.313,7.313,0,0,1-1.785,1.3,8.583,8.583,0,0,1-10.133-1.5,7.221,7.221,0,0,1,3.27-11.834,6.9,6.9,0,0,1,8.078,3.991,7.559,7.559,0,0,1,.547,4.261c-.006.036-.018.072-.03.132Zm-.055-2.669h7.219a3.718,3.718,0,0,0-7.219,0Z'
							transform='translate(-3175.047 -482.76)'
							fill='url(#linear-gradient-4)'
						/>
						<path
							id='Path_9_8_'
							d='M3050.973,496.6c-2.422,4.742-4.82,9.418-7.237,14.149L3036.5,496.6h.7c.8,0,1.6.012,2.4-.006a.525.525,0,0,1,.571.343c1.118,2.206,2.254,4.4,3.384,6.593.048.1.1.186.174.319.066-.126.12-.216.168-.313l3.426-6.671a.417.417,0,0,1,.433-.271C3048.815,496.607,3049.861,496.6,3050.973,496.6Z'
							transform='translate(-2964.687 -489.694)'
							fill='url(#linear-gradient-5)'
						/>
						<path
							id='Path_10_8_'
							d='M2797.37,437.262h-3.114V426.7H2791.3v-3.119h2.951v-1.5c0-.469-.006-.944.006-1.412a.341.341,0,0,1,.126-.264c.968-.5,1.942-.986,2.963-1.5v4.67h3.258v3.113h-3.24Z'
							transform='translate(-2734.224 -416.669)'
							fill='url(#linear-gradient-6)'
						/>
						<path
							id='Path_11_8_'
							d='M2163.692,492.765a3.3,3.3,0,0,0-2.572.487,3.257,3.257,0,0,0-1.437,2.849v7.6H2156.6V490.036h3.065v1.394l.066.048a5.62,5.62,0,0,1,1.767-1.376,4.787,4.787,0,0,1,2.194-.511Z'
							transform='translate(-2137.672 -483.111)'
							fill='url(#linear-gradient-7)'
						/>
						<path
							id='Path_12_8_'
							d='M2968.6,497h3.065v13.662H2968.6Z'
							transform='translate(-2900.867 -490.075)'
							fill='url(#linear-gradient-8)'
						/>
						<path
							id='Path_15_8_'
							d='M2967.182,387.649a1.842,1.842,0,1,1-1.815-1.851h.006A1.836,1.836,0,0,1,2967.182,387.649Z'
							transform='translate(-2896.072 -385.557)'
							fill='url(#linear-gradient-9)'
						/>
					</g>
					<g
						id='Group_3'
						data-name='Group 3'
						transform='translate(136.502 3.089)'>
						<path
							id='Path_40_8_'
							d='M3581.836,496.069a18.1,18.1,0,0,1-1.49,1.869,6.689,6.689,0,0,1-10.368-1.07,7.564,7.564,0,0,1,.637-9.28,6.744,6.744,0,0,1,11.011,1.394.782.782,0,0,0,.192.252V485.8h1.442v13.656h-1.418v-3.384Zm-5.86,2.4a5.845,5.845,0,1,0-5.848-5.842,5.846,5.846,0,0,0,5.848,5.842Z'
							transform='translate(-3565.909 -480.304)'
							fill='#3b2a82'
						/>
						<path
							id='Path_45_8_'
							d='M3859.012,506.586h-1.22c-.06,0-.115-.006-.193-.012V492.9h1.406v13.686Z'
							transform='translate(-3837.459 -487.406)'
							fill='#3b2a82'
						/>
						<path
							id='Path_46_8_'
							d='M3523.768,688.134a1.3,1.3,0,0,1-1.268-1.262,1.271,1.271,0,1,1,2.542.012A1.285,1.285,0,0,1,3523.768,688.134Z'
							transform='translate(-3522.5 -668.522)'
							fill='#3b2a82'
						/>
						<path
							id='Path_48_8_'
							d='M3849.765,401.5a1.266,1.266,0,0,1,1.274,1.244,1.271,1.271,0,0,1-2.543.012A1.274,1.274,0,0,1,3849.765,401.5Z'
							transform='translate(-3828.903 -401.5)'
							fill='#3b2a82'
						/>
					</g>
				</g>
				<g
					id='Group_4851'
					data-name='Group 4851'
					transform='translate(325.966 161.25)'>
					<g
						id='Group_4851-2'
						data-name='Group 4851'
						transform='translate(0 0)'>
						<path
							id='Path_3567'
							data-name='Path 3567'
							d='M321.545,535.336,301.667,545.8a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3L298.882,521.3,321.5,532.341A1.68,1.68,0,0,1,321.545,535.336Z'
							transform='translate(-275.322 -501.739)'
							fill='url(#linear-gradient-10)'
						/>
						<path
							id='Path_3568'
							data-name='Path 3568'
							d='M321.545,422.535,301.667,433a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3L298.882,408.5,321.5,419.54A1.68,1.68,0,0,1,321.545,422.535Z'
							transform='translate(-275.322 -395.709)'
							fill='url(#linear-gradient-11)'
						/>
						<path
							id='Path_3569'
							data-name='Path 3569'
							d='M321.545,310.365l-19.878,10.465a5.978,5.978,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3l22.617-11.044L321.5,307.369A1.68,1.68,0,0,1,321.545,310.365Z'
							transform='translate(-275.322 -290.271)'
							fill='url(#linear-gradient-12)'
						/>
						<path
							id='Path_3570'
							data-name='Path 3570'
							d='M321.545,208.824l-19.878,10.465a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3l19.994-9.763a5.979,5.979,0,0,1,5.247,0l19.994,9.763A1.68,1.68,0,0,1,321.545,208.824Z'
							transform='translate(-275.322 -195.459)'
							fill='url(#linear-gradient-13)'
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}

//LogoWithout text
export const LogoWithoutText: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			width='39.12'
			height='36.75'
			className='logo-without-text-icon-svg'
			viewBox='0 0 47.12 44.75'>
			<defs>
				<linearGradient
					id='linear-gradient'
					x1='0.5'
					x2='0.5'
					y2='1'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#8f006d' />
					<stop offset='1' stop-color='#4c00b3' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-2'
					x1='0.5'
					x2='0.5'
					y2='1'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#c8006d' />
					<stop offset='1' stop-color='#8200b3' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-3'
					x1='0.5'
					x2='0.5'
					y2='1'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#c8006d' />
					<stop offset='1' stop-color='#c5009f' />
				</linearGradient>
				<linearGradient
					id='linear-gradient-4'
					x1='0.5'
					y1='-0.078'
					x2='0.5'
					y2='1.101'
					gradientUnits='objectBoundingBox'>
					<stop offset='0.001' stop-color='#ff3067' />
					<stop offset='1' stop-color='#ff009f' />
				</linearGradient>
			</defs>
			<g id='AdCreative' transform='translate(-325.966 -161.25)'>
				<g
					id='Group_4851'
					data-name='Group 4851'
					transform='translate(325.966 161.25)'>
					<g
						id='Group_4851-2'
						data-name='Group 4851'
						transform='translate(0 0)'>
						<path
							id='Path_3567'
							data-name='Path 3567'
							d='M321.545,535.336,301.667,545.8a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3L298.882,521.3,321.5,532.341A1.68,1.68,0,0,1,321.545,535.336Z'
							transform='translate(-275.322 -501.739)'
							fill='url(#linear-gradient)'
						/>
						<path
							id='Path_3568'
							data-name='Path 3568'
							d='M321.545,422.535,301.667,433a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3L298.882,408.5,321.5,419.54A1.68,1.68,0,0,1,321.545,422.535Z'
							transform='translate(-275.322 -395.709)'
							fill='url(#linear-gradient-2)'
						/>
						<path
							id='Path_3569'
							data-name='Path 3569'
							d='M321.545,310.365l-19.878,10.465a5.978,5.978,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3l22.617-11.044L321.5,307.369A1.68,1.68,0,0,1,321.545,310.365Z'
							transform='translate(-275.322 -290.271)'
							fill='url(#linear-gradient-3)'
						/>
						<path
							id='Path_3570'
							data-name='Path 3570'
							d='M321.545,208.824l-19.878,10.465a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3l19.994-9.763a5.979,5.979,0,0,1,5.247,0l19.994,9.763A1.68,1.68,0,0,1,321.545,208.824Z'
							transform='translate(-275.322 -195.459)'
							fill='url(#linear-gradient-4)'
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}
